import { SDLUtil, RequestUtil, StringUtil, DateUtil } from '@/utils';

const setData = ({ commit }, data) => {
  commit('SET_DATA_IAM_VIOLATIONS', data);
};

const setCount = ({ commit }, data) => {
  commit('SET_COUNT_IAM_VIOLATIONS', data);
};

export default {
  async SEARCH_IAM_VIOLATIONS(store, param) {
    param = { ...param
    };
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/monitoring/security/violations/iam-check-list?${StringUtil.queryStringfy(param)}`);

    setData(store, data.data);
  },

  async COUNT_IAM_VIOLATIONS(store, param) {
    param = { ...param
    };
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/monitoring/security/violations/iam-check-count?${StringUtil.queryStringfy(param)}`);

    setCount(store, data.data);
  },
};



// WEBPACK FOOTER //
// ./src/vuex/monitoring/security/violations/IamViolationAction.js